import { Button, createStyles, IconButton, Theme, Typography, WithStyles, withStyles } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
    toggleUpload?: () => void;
    isUploading: boolean;
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        uploadButton: {
            position: 'absolute',
            right: theme.spacing(10),
            top: theme.spacing(2),
            backgroundColor: theme.palette.warning.main,
            color: 'white',
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

const GalleryPopupTitle = withStyles(styles)(
    ({ children, classes, onClose, toggleUpload, isUploading, ...other }: DialogTitleProps) => {
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant='h6'>{children}</Typography>
                {toggleUpload && (
                    <Button variant='contained' onClick={() => toggleUpload()} className={classes.uploadButton}>
                        {isUploading ? 'Close' : 'Upload media'}
                    </Button>
                )}
                {onClose ? (
                    <IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    },
);

export default GalleryPopupTitle;
